import { FunctionComponent } from 'react';
import HeaderMobileWrapper from './HeaderMobileWrapper';
import SiteHeader from './SiteHeader';
import { ISiteHeaderProps } from './types';
import { useResponsive } from 'src/hooks/useResponsive';

const SiteHeaderWrapper: FunctionComponent<ISiteHeaderProps> = (props) => {
  const isMobile = useResponsive('down', 'md');
  const isMaintenanceActive = !!(props.site.isMaintenance && props.site.maintenanceActivatedBy);
  const navbar_tabs_height = 80;
  const baseHeight = isMaintenanceActive ? 210 : 150;
  const spacerHeight = props.isFullscreen ? baseHeight - navbar_tabs_height : baseHeight;
  return isMobile ? (
    <HeaderMobileWrapper spacerHeight={spacerHeight}>
      <SiteHeader {...props} />
    </HeaderMobileWrapper>
  ) : (
    <SiteHeader {...props} />
  );
};

export default SiteHeaderWrapper;
